<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="cardTitle"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="securitiesBlock"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleContinueButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "global.continueButton" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "global.backButton" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="securitiesBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #securitiesBlock>
  <div class="input-container">
    <app-currency-input
      [label]="'securities.factoringLabel'"
      [control]="factoring"
    ></app-currency-input>
  </div>
  <div class="input-container">
    <app-currency-input
      [label]="'securities.companyMortgageLabel'"
      [control]="companyMortgage"
    ></app-currency-input>
  </div>
  <div class="infobox-container">
    <app-infobox
      [title]="'securities.infobox.title' | translate"
      [content]="'securities.infobox.content' | translate"
    >
    </app-infobox>
  </div>
  <div *ngIf="error" class="error">
    {{ error }}
  </div>
</ng-template>
